import {Component, input} from '@angular/core';
import {HashMap, TranslocoPipe} from '@jsverse/transloco';
import {DirectusTooltipComponent} from '../../directus-tooltip/directus-tooltip.component';

@Component({
  selector: 'app-panel-header',
  imports: [TranslocoPipe, DirectusTooltipComponent],
  templateUrl: './panel-header.component.html',
})
export class PanelHeaderComponent {
  titleKey = input.required<string>();
  title = input<string>();
  titleParams = input<HashMap<string | number>>({});
  tooltipKey = input<string>();
  tooltip = input<string>();
  icon = input<string>();
  iconColor = input<string>();
}
